<template functional>
    <span class="vrm-modal__close-handle sg-vrm-icon_060_cross-round-24px mfp-close" />
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component()
export default class ModalCloseHandle extends Vue {}
</script>
